export default __webpack_public_path__ + "static/media/kitchen4-afterC-480w.007b1bee.png";